<template>
  <!-- Main modal -->
  <div
    ref="modal"
    tabindex="-1"
    aria-hidden="true"
    :class="elevated ? 'z-[9200]' : 'z-[1010]'"
    class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
  >
    <div
      class="relative p-4 w-full max-h-full"
      :class="sizeClass"
    >
      <!-- Modal content -->
      <div class="relative bg-white rounded-lg shadow">
        <!-- Modal header -->
        <div
          class="flex items-center justify-between p-4 md:px-5 border-b rounded-t"
          v-if="title"
        >
          <h3 class="text-xl font-semibold text-gray-900">
            {{ title }}
          </h3>
          <button
            type="button"
            @click.prevent="$emit('close')"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-7 h-7 ms-auto inline-flex justify-center items-center"
          >
            <svg
              class="w-2 h-2"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>

        <!-- Modal Header slot-->
        <div
          class="flex items-center justify-between p-4 md:px-5 border-b rounded-t dark:border-gray-600"
          v-if="$slots.header"
        >
          <slot name="header" />
        </div>

        <!-- Modal body -->
        <slot name="body" />

        <!-- Modal footer -->
        <div
          class="flex items-center p-4 md:p-5 border-t border-gray-200 rounded-b"
          :class="footerClass"
          v-if="$slots.footer"
        >
          <slot name="footer" />
        </div>

        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "flowbite"

export default {
  name: "PortalModal",

  props: {
    title: { required: false, type: String, default: null },
    sizeClass: { required: false, type: String, default: "max-w-3xl" },
    closeOnBackdropClick: { required: false, type: Boolean, default: true },
    footerClass: { required: false, type: String, default: "" },
    elevated: { required: false, type: Boolean, default: false },
  },

  emits: ["close"],

  data() {
    return {
      modal: null,
    }
  },

  mounted() {
    const backdropClasses = this.elevated
      ? `z-[9100] bg-gray-900/80 fixed inset-0`
      : `z-[1000] bg-gray-900/80 fixed inset-0`
    this.modal = new Modal(this.$refs.modal, {
      placement: "center",
      backdrop: this.closeOnBackdropClick ? "dynamic" : "static",

      backdropClasses: backdropClasses,

      onHide: () => this.$emit("close"),
    })
    this.modal.show()
  },

  beforeUnmount() {
    this.modal.destroy()
    const items = document.querySelectorAll("body.overflow-hidden")
    if (items.length > 0) {
      items[0].classList.remove("overflow-hidden")
    }
  },
}
</script>


